<template>
  <div id="paper-root">
    <a-layout theme="light">
      <a-layout-header :style="_isMobile()?[{height: 'auto'}]:[]">
        <a-row id="paper-header">
          <a-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
          <span v-if="!_isMobile()">
              <a-tooltip title="全屏">
                <a-button v-if="!isFullscreen()" type="default" @click="fullScreen" icon="fullscreen"></a-button>
              </a-tooltip>
              <a-tooltip title="退出全屏">
                <a-button v-if="isFullscreen()" type="default" @click="exitFullscreen" icon="fullscreen-exit"></a-button>
              </a-tooltip>
              <a-divider type="vertical" />
            </span>
            <span @click="paperDescVisible=true"><a-icon v-if="userPaperInfo.paperDesc" type="exception" /> {{userPaperInfo.examName || userPaperInfo.paperName}}</span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
            <span v-if="examStatus==0">
              <span>考试已结束，耗时：</span>
              <span class="remain-time">{{formatTime(duration)}}</span>
            </span>
            <span v-if="examStatus==1" >
              <span>剩余：</span>
              <span class="remain-time">{{remaining>0?remainTimeText:'不限'}}</span>
            </span>
            <span v-if="userPaperInfo.userPaperStatus>1">
              <span>总分：</span><span class="remain-time">{{userPaperInfo.totalScore}}</span>
              <span>得分：</span><span class="remain-time">{{userPaperInfo.gotScore}}</span>
            </span>
          </a-col>
          <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6" >
            <span v-if="examStatus==1">
              <a-button type="primary" @click="savePaper">保存</a-button>
              <a-divider type="vertical" />
              <a-button type="danger" @click="requestSubmitPaper">交卷</a-button>
            </span>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout>
        <a-layout-sider :collapsedWidth="0" :collapsible="_isMobile()" :zeroWidthTriggerStyle="{background:'#7c7c7c57', color:'#000'}" :defaultCollapsed="_isMobile()">
          <template slot="trigger">
            <a-icon type="list"></a-icon>
          </template>
          <a-card :bordered="false" class="question-index">
            <a-row>
              <h3 v-if="$store.getters.userInfo">学生：{{$store.getters.userInfo.realname || $store.getters.userInfo.username}}</h3>
              <div v-for="(q, i) in paperQuestion" :key="i">
                <a-col class="question-section" :span="24" v-if="q.questionSection">{{ q.questionSection }}</a-col>
                <a-col :span="6">
                  <a-tag :color="isWriteAnswer(i) ? 'blue' : ''" @click="jumpQuestion(i)">{{ i + 1 }}</a-tag>
                </a-col>
              </div>
            </a-row>
            <div class="tip">
              <p>说明：</p>
              <p>1.蓝底色块：已做答状态</p>
              <p>2.白底色块：未作答状态</p>
            </div>
          </a-card>
        </a-layout-sider>
        <a-layout-content
          :style="{ minHeight: '80vh', height: 'calc(100vh - ' + heightOffset + 'px', overflow: 'auto' }"
        >
          <a-card class="paper-content" :bordered="false">
            <div v-for="(q, qi) in paperQuestion" :key="qi">
              <!-- 题目分类 -->
              <div class="question-section" v-if="q.questionSection">
                <span>{{ questionSections[qi].text }}</span>
                <span>（共{{questionSections[qi].count}}题，每题{{q.questionScore}}分，共{{questionSections[qi].score}}分）</span>
              </div>
              
              <a-card :bordered="false" class="question-card" :id="'q-' + qi">
                <a-row>
                  <!-- 题干 -->
                  <a-col>
                    <div v-if="q.questionType != 4" class="question-stem">
                      <span>{{ qi + 1 }}. （{{ q.questionScore }}分）</span>
                      <div v-html="q.questionStem"></div>
                    </div>
                    <div v-if="q.questionType == 4" :id="'question-stem-'+q.id" ></div>
                  </a-col>
                  <!-- <a-divider v-if="q.questionType != 4"/> -->
                  <a-col v-if="q.questionType != 4 && paperAnswer[qi]">
                    <!-- 单选 -->
                    <a-radio-group :disabled="examStatus!=1" v-if="q.questionType == 1" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        {{ index2letter(oi) }}
                        <div class="question-options">
                          <div class="option" v-html="o.item"></div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group :disabled="examStatus!=1" v-if="q.questionType == 2" v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        {{ index2letter(oi) }}
                        <div class="question-options">
                          <div class="option" v-html="o.item"></div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group :disabled="examStatus!=1" v-if="q.questionType == 3" v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true">正确</a-radio>
                      <a-radio value="false">错误</a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <!-- 已改为虚拟DOM，直接在题干的下划线填写答案 -->
                    <!-- <div v-if="q.questionType == 4">
                      <a-input
                        :readOnly="examStatus!=1"
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                        :placeholder="'第' + oi + '空回答'"
                      />
                    </div> -->
                    <!-- 主观题 阅读分析-->
                    <div v-if="q.questionType == 5 || q.questionType == 6">
                      <a-textarea
                        :readOnly="examStatus!=1"
                        :auto-size="{ minRows: 5, maxRows: 20 }"
                        placeholder="作答区"
                        v-model="paperAnswer[qi]['myAnswer']"
                      ></a-textarea>
                    </div>

                    <!-- 编程题 -->
                    <div v-if="q.questionType == 7">
                      <a-button :disabled="examStatus!=1" type="primary" size="large" @click="openEditor(q)">{{isWriteAnswer(qi)?'修改程序':'开始作答'}}</a-button>
                    </div>
                    <!-- OJ编程题 -->
                    <div v-if="q.questionType == 8">
                      <a-button :disabled="examStatus!=1" type="primary" size="large" @click="openOJEditor(q)">{{isWriteAnswer(qi)?'修改程序':'开始作答'}}</a-button>
                    </div>
                  </a-col>
                  <a-col v-if="userPaperInfo.userPaperStatus>1">
                    <a-divider></a-divider>
                    <a-col :span="8">
                      <p style="color:red;">参考答案:
                        <span>{{answer2Text(q)}}</span>
                        <j-upload
                          v-model="q.questionAnalysisFile"
                          text="参考答案"
                          :uploadTarget="'qiniu'"
                          disabled
                          :number="1"
                          :trigger-change="true"
                        ></j-upload>
                      </p>
                    </a-col>
                    <a-col :span="10">
                        <p style="color:red;">解析：</p>
                        <div v-html="q.questionAnalysis"></div>
                    </a-col>
                  </a-col>
                </a-row>
              </a-card>
            </div>
          </a-card>
        </a-layout-content>
      </a-layout>
    </a-layout>
    <a-modal
      :width="'800px'"
      :visible="paperDescVisible"
      title="试卷介绍"
      :destroyOnClose="true"
      :footer="null"
      @cancel="paperDescVisible=false"
    >
      <div v-html="userPaperInfo.paperDesc"></div>
    </a-modal>
    <a-modal
      :width="'100%'"
      :visible="editorVisible"
      :maskClosable="false"
      :dialogStyle="{ top: 0 }"
      :destroyOnClose="true"
      :footer="null"
      @cancel="editorVisible=false"
    >
    <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
      <div slot="title">
        <a-row>
           <a-col :span="8">
            <span>{{currentQuestionInfo.questionName}}</span>
           </a-col>
          <a-col :span="8" v-if="examStatus == 1">
            <span>剩余：</span>
            <span class="remain-time">{{remaining>0?remainTimeText:'不限'}}</span>
          </a-col>
          <a-col :span="8">
            <a-button v-if="currentQuestionInfo.questionType!=8 && currentQuestionInfo.questionStem" type="primary" @click="viewQuestionStem(currentQuestionInfo)">查看题目</a-button>
          </a-col>
        </a-row>
        </div>
      <iframe
        :src="editorUrl"
        id="player"
        frameborder="0"
        width="100%"
        style="height:calc(100vh - 48px);"
        scrolling="no"
      ></iframe>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction } from '@/api/manage'
import {mixinDevice} from '@/utils/mixin.js'
import JUpload from '@/components/jeecg/JUpload'
export default {
  name: 'Examine',
  mixins: [mixinDevice],
  components: {JUpload},
  data() {
    return {
      heightOffset: 0,
      paperId: '',
      departId: '',
      userPaperInfo: {}, //用户答题卡信息
      paperQuestion: [], //已经过转换的题目信息
      questionSections:{},//题目分类信息
      paperAnswer: [], // 答题卡信息
      userPaperId: '', // 答题卡ID
      paperDescVisible: false, //试卷介绍是否可见
      editorVisible: false,
      editorUrl: '',
      duration: 0, //用时
      remaining: 0, //剩余时间
      remainTimeText: '',
      interval: undefined,
      examStatus: -1, //考试状态 -1预览 0已结束 1正在考试
      exitingFullscreen: false, //是否正在退出全屏
      canSave: true, //防止保存试卷高频点击
      canSubmit: true, //防止提交试卷高频点击
      currentQuestionInfo: {}
    }
  },
  created() {
    if(this.$route.query.id){
      this.paperId = this.$route.query.id
    }
    if(this.$route.query.departId){
      this.departId = this.$route.query.departId
    }
    //继续作答，传入答题卡ID
    if(this.$route.query.userPaperId){
      this.userPaperId = this.$route.query.userPaperId
    }
    //拦截未登录
    if(!this.$store.getters.userInfo){
      this.$info({
        title: '未登录',
        content: '请登录后再打开本页面进行考试',
        okText: "去登录",
        onOk() {
          // window.location.href = "/user/login?redirect=" + window.location.pathname + window.location.search
          window.location.href = "/login?type=idcard&backUrl=" + window.location.pathname + window.location.search
        },
      });
    }
    // this.getMyPaperInfo()
  },
  mounted() {
    var that = this
    let paperHeader = document.getElementById('paper-header')
    this.heightOffset = paperHeader.clientHeight + paperHeader.offsetTop

    //contextmenu 禁用右键菜单
    document.addEventListener('contextmenu',function(e){
        e.preventDefault();
    })
    //禁止复制  selectstart
    document.addEventListener('selectstart',function(e){
        e.preventDefault();
    })

    // 禁止调试
    //eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('2 i=\'\',3=["e",""];(4(a){a[3[0]]=3[1]})(8);2 9=["g"];!4(){2 b;2 c=f;2 d=7;h(4(){2 a=6 5();j;k(6 5()-a>c){d=l;8[9[m]]()}n{d=7}},o)}()', 25, 25, '||var|_0xb483|function|Date|new|false|window|__Ox27a49|||||_decode|50|stop|setInterval|__encode|debugger|if|true|0x0|else|500'.split('|'), 0, {}))

    //拦截未登录
    if(!this.$store.getters.userInfo){
      return
    }

    //刷新页面拦截
    window.onbeforeunload = function(e){
      e.returnValue = "确定要离开页面？"
    }

    //监听代码提交事件
    document.addEventListener('submit', function(e){
      that.onCodeSubmit(e.detail)
    })
    document.addEventListener('submitOJ', function(e){
      that.onOJCodeSubmit(e.detail)
    })

    //监听页面失去焦点
    window.onblur = function(){
      if(!that.editorVisible){
        //3秒后记录日志
        window.jumping = setTimeout(function(){
          that.jumpOutLog()
        }, 3000)
      }
    }
    document.addEventListener('onEditorBlur', function(e){
      if(that.editorVisible){
        that.jumpOutLog()
      }
    })
    //回到考试，清除正在跳出页面的状态
    window.onfocus = function(){
      clearTimeout(window.jumping)
    }
    //进入考试的提示
    const h = this.$createElement;
    this.$info({
      title: '注意事项',
      content: h('div', {}, [
        h('p', '1、考试一旦开始无法暂停,请注意考试剩余时间'),
        h('p', '2、考试期间不得随意切出考试页面、退出全屏'),
        h('p', '3、做完题目一定记得点击页面上方提交试卷'),
      ]),
      okText: "开始考试",
      onOk() {
        that.getMyPaperInfo()
      },
    });
  },
  beforeRouteLeave(to, from, next){
    if(this.examStatus != 1){
      next()
      return;
    }
    let that = this
    this.$confirm({
      title: '提示',
      content: <div>
                <p>您即将要离开考试页面</p>
                <h2>是否要保存试卷? </h2>
                </div>,
      onOk() {
        that.savePaper().then(()=>{
          clearInterval(that.interval)
          that.interval = null;
          window.onbeforeunload = null;
          next()
        })
      },
      onCancel() {
        next()
      },
    });
  },
  //离开页面
  beforeDestroy(){
    clearInterval(this.interval)
    this.interval = null;
    window.onbeforeunload = null;
    window.onblur = null
    this.exitFullscreen()
  },
  methods: {
    //获取答题卡
    getMyPaperInfo() {
      this.paperQuestion = []
      return getAction(`/teaching/teachingPaper/getMyPaper?paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`).then((res) => {
        if (res.success && res.result != null) {
          this.parseUserPaperInfo(res.result.userPaper)
          this.parseQuestion(res.result.question)
          this.fullScreen()
        } else {
          this.$message.error(res.message)
        }
      }).catch(e=>{
        console.log(e);
      })
    },
    //解析用户答卷信息
    parseUserPaperInfo(info){
      if(!info){
        console.log("未解析到用户答题卡");
        return
      }
      this.userPaperInfo = info
      this.paperId = info.paperId
      this.userPaperId = info.userPaperId
      this.departId = info.departId
      this.examStatus = (info==null || info.userPaperStatus==0) ? 1 : 0
      //设置耗时
      if(info && info.duration){
        this.duration = info.duration
      }
      if(this.userPaperInfo.timeLimit == 0){ //不限时
        this.remaining = -1
      }else if(this.userPaperInfo.timeLimit > 0 && info && info.duration){ 
        //继续做题，减去已消耗时间
        this.remaining = this.userPaperInfo.timeLimit * 60 - info.duration
        if(this.remaining <= 0){ //虽然正在考试，但是已超时
          this.examStatus = 0
          this.onTimeout()
        }
      }else{ 
        //新开始做题
        this.remaining = this.userPaperInfo.timeLimit * 60
      }
    },
    //解析题目
    parseQuestion(question) {
      let currentSection = null;
      for (let qi in question) {
        let q = question[qi]
        //解析题目分类
        
        if(q.questionSection){
          currentSection = qi
          this.questionSections[qi] = {
            text:q.questionSection,
            count:0,
            score:0
          }
        }
        if(currentSection!=null){
          this.questionSections[currentSection].count += 1;
          this.questionSections[currentSection].score += q.questionScore;
        }
        

        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
        }
        this.paperQuestion.push(q)
        
        if (q.myAnswer != null || q.myAnswerFile != null) {
          this.paperAnswer.push({ qid: q.questionId, myAnswer: this.parseAnswer(q.questionType, q.myAnswer), myAnswerFile: q.myAnswerFile })
        } else {
          if (q.questionType == 2 || q.questionType == 4) {
            //填空题 多选题结构
            this.paperAnswer.push({ qid: q.questionId, myAnswer: [] })
          } else {
            this.paperAnswer.push({ qid: q.questionId, myAnswer: '' })
          }
        }
        //渲染填空题dom
        if(q.questionType == 4){
          this.renderGapFillingStemDom(q, qi)
        }
      }
      //正在考试，初始化倒计时
      if(this.examStatus == 1){
        this.startCountDown()
      }
    },
    //解析答题信息
    parseAnswer(type, answer){
      if(answer == ""){
          return ""
        }
      if (type == 1 || type == 2 || type == 4) {
        let myAnswer = JSON.parse(answer)
        return myAnswer
      }else{
        return answer
      }
    },
    //倒计时
    startCountDown(){
      var that = this
      this.interval = setInterval(function () {
        that.remainTimeText = that.formatTime(that.remaining)
        if(that.remaining > 0){
          that.remaining -= 1
        }
        that.duration += 1
        if(that.remaining == 300){
          that.$message.info('考试还剩5分钟，请注意时间')
        }else if(that.remaining == 60){
          that.savePaper()
          that.$message.info('考试只剩1分钟，建议立即交卷')
        }
        if (that.remaining == 0) {
          that.onTimeout()
        }
      }, 1000)
    },
    formatTime(time){
      var minutes = Math.floor(time / 60);
      var seconds = Math.floor(time % 60);
      return minutes + ":" + seconds
    },
    //到达考试时间
    onTimeout(){
      this.examStatus = 0
      clearInterval(this.interval)
      this.$message.warn('考试已结束')
      this.exitFullscreen()
      //强制提交
      //this.submitPaper()
    },
    //保存试卷
    savePaper() {
      let that = this
      if(!this.canSave){
        this.$message.warning('点击太快啦，请稍后再试')
        return
      }else{
        this.canSave = false
        setTimeout(function(){
          that.canSave = true
        }, 5000)
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=0&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          this.userPaperId = res.result
          this.$message.success('保存成功')
        } else {
          this.$message.warn(res.message)
        }
      })
    },
    //点击交卷
    requestSubmitPaper(){
      let that = this
      //统计未作答题目
      let undoCount = 0
      for(let i=0; i<this.paperQuestion.length;i++){
        if(!this.isWriteAnswer(i)){
          undoCount++
        }
      }
      this.$confirm({
        title: '交卷',
        content: <div>
                  {undoCount>0?<h3 style="color:red">你还有{undoCount}题未作答</h3>:''}
                  <h2>是否立即交卷? </h2>
                  <h3>交卷后考试结束</h3>
                  </div>,
        onOk() {
          that.submitPaper()
        },
        onCancel() {
        },
      });
    },
    //提交试卷
    submitPaper() {
      let that = this
      if(!this.canSubmit){
        this.$message.warning('点击太快啦，请稍后再试')
        return
      }else{
        this.canSubmit = false
        setTimeout(function(){
          that.canSubmit = true
        }, 5000)
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=1&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          this.userPaperId = res.result
          this.examStatus = 0
          this.$message.success('交卷成功')
          clearInterval(this.interval)
          this.exitFullscreen()
          //history.back()
        } else {
          this.$message.warn(res.message)
        }
      })
    },
    //跳转到题目
    jumpQuestion(i) {
      this.$el.querySelector('#q-' + i).scrollIntoView({ block: 'start', behavior: 'smooth' })
    },
    //索引转大写字母
    index2letter(index) {
      if (index < 0 || index > 25) {
        return ''
      }
      return String.fromCharCode(65 + index)
    },
    //答案转字符
    answer2Text(question){
      if(question['questionAnswer'] == null){
        return ""
      }
      let that = this
      switch(question.questionType){
        case 1:
          return this.index2letter(parseInt(question['questionAnswer']))
        case 2:
          return JSON.parse(question['questionAnswer']).map(a=>{
            return that.index2letter(parseInt(a))
          }).join(' ')
        case 3:
          return question['questionAnswer']==="true"?"正确":"错误"
        case 4:
          return JSON.parse(question['questionAnswer']).map(a=>{
            return  a['item'].join("|")
          }).join("，")
        case 5:
          return "关键词：" + JSON.parse(question['questionAnswer']).join("，")
        default:
           return question['questionAnswer']
      }
    },
    //是否已作答
    isWriteAnswer(i) {
      if(this.paperAnswer[i] == undefined){
        return false
      }
      if ('myAnswerFile' in this.paperAnswer[i] && this.paperAnswer[i]['myAnswerFile']) {
        return true
      }
      if (typeof this.paperAnswer[i]['myAnswer'] == 'string' && this.paperAnswer[i]['myAnswer'] != '') {
        return true
      } else if (typeof this.paperAnswer[i]['myAnswer'] == 'number' && this.paperAnswer[i]['myAnswer'] != null) {
        return true
      } else if (typeof this.paperAnswer[i]['myAnswer'] == 'object' && this.paperAnswer[i]['myAnswer'].length > 0) {
        return true
      }
      return false
    },
    //打开编辑器
    openEditor(questionInfo) {
      this.editorVisible = true
      this.editorUrl = this.getEditorUrl(questionInfo)
    },
    //打开OJ编辑器
    openOJEditor(questionInfo) {
      this.editorVisible = true
      this.editorUrl = this.getEditorUrl(questionInfo)
    },
    //获取编辑器地址
    getEditorUrl(questionInfo) {
      this.currentQuestionInfo = questionInfo
      console.log(questionInfo);
      let url
      switch (questionInfo.codeType) {
        case 1:
          url = '/scratch3/index.html?workName=考试'
          break
        case 2:
          url = '/scratch3/index.html?workName=考试'
          break
        case 3:
          url = '/scratchjr/editor.html?mode=edit&workName=考试'
          break
        case 4:
          url = '/onlinecode/index.html?lang=turtle&workName=考试'
          break
        case 5:
          url = '/onlinecode/index.html?lang=python&workName=考试'
          break
        case 6:
          url = '/onlinecode/index.html?lang=c&workName=考试'
          break
        case 7:
          url = '/onlinecode/index.html?lang=cpp&workName=考试'
          break
        case 8:
          url = '/onlinecode/index.html?lang=java&workName=考试'
          break
      }
      if(questionInfo.myAnswerFile){
        url+="&workId=" + questionInfo.myAnswerFile
      }
      url += '&scene=exam&questionId=' + questionInfo.questionId + '&paperId=' + questionInfo.paperId + "&userPaperId=" + this.userPaperId
      if(questionInfo.id){ //修改程序传入answerId
        url += "&answerId=" + questionInfo.id
      }
      return url
    },
        //查看题干
    viewQuestionStem(questionInfo){
      console.log(questionInfo);
      const h = this.$createElement;
      this.$info({
        width:600,
        title: '查看题目',
        content: h('div',{domProps: {innerHTML: questionInfo.questionStem}}),
        onOk() {
        },
        onCancel() { },
      });
    },
    //当代码提交成功
    onCodeSubmit(info) {
      if(this.editorVisible == false){
        return
      }
      let that = this
      let workId = info.workId
      let questionId = info.questionId
      let paperId = info.paperId
      if(paperId != this.paperId){
        alert('参数错误')
        return
      }
      for(var i=0;i<this.paperQuestion.length; i++){
        if(this.paperQuestion[i].questionId == questionId){
          this.paperQuestion[i]['myAnswerFile'] = workId
          this.paperAnswer[i]['myAnswerFile'] = workId
        }
      }
      this.$confirm({
        title: '提交成功',
        content: <h2>是否关闭编辑器?</h2>,
        onOk() {
          that.editorVisible = false
        },
        onCancel() {},
      });
    },
    //当OJ代码提交成功
    onOJCodeSubmit(info){
      if(this.editorVisible == false){return}
      let id = info.id
      let answer = info.answer
      let questionId = info.questionId
      for(var i=0;i<this.paperQuestion.length; i++){
        if(this.paperQuestion[i].questionId == questionId){
          this.paperQuestion[i]['id'] = id
          this.paperQuestion[i]['myAnswer'] = answer
          this.paperAnswer[i]['myAnswer'] = answer
        }
      }
      let that = this
      console.log(info);
      this.$confirm({
        title: '提交成功',
        content: <h2>是否关闭编辑器?</h2>,
        onOk() {
          that.editorVisible = false
        },
        onCancel() {},
      });
    },
    //生成填空题虚拟DOM
    renderGapFillingStemDom(question, index){
      if(question.questionType != 4){
        return;
      }
      let stem = question.questionStem
      //替换下划线为input组件
      let reg = /(_)\1{2,}/g
      let gaps = stem.match(reg)
      for(let i=0; i<gaps.length; i++){
        let gap = gaps[i]
        stem = stem.replace(gap, 
        `<a-input
          style="display:inline;border-radius:0;border:none;border-bottom:solid 1px;width:${gap.length * 7}px"
          placeholder="${i+1}"
          :readOnly="examStatus!=1"
          v-model="value[${i}]"
        />`)

      }
      stem = "<div>"+stem+"</div>"
      //定义组件
      let FillillStemCompnent = Vue.extend({
        template: stem,
        data: function() {
          return {
          }
        },
        props:{
          value:{
            type: Array
          },
          examStatus:{
            type: Number,
            default: 1
          }
        },
        created: function(){
        },
      })
      //挂载组件
      this.$nextTick(()=>{
        new FillillStemCompnent({propsData: {
          value: this.paperAnswer[index]['myAnswer'], 
          examStatus: this.examStatus}
          }).$mount('#question-stem-' + question.id)
      })
    },
    //页面跳出记录
    jumpOutLog() {
      if(!this.exitingFullscreen && this.examStatus==1){
        postAction(`/teaching/teachingPaper/examLog?userPaperId=${this.userPaperId}&type=1`,{}).then(res=>{
          if(this.userPaperInfo.jumpOutLimit > -1 && res.result > this.userPaperInfo.jumpOutLimit){
            //中断考试
            this.examStatus = 0
            clearInterval(this.interval)
            this.$error({
              title: '警告',
              content: '考试中途不得切换页面，但由于您切换页面次数过多，已强制中断考试！',
            });
          }else if(this.userPaperInfo.jumpOutLimit > -1){
            this.$error({
              title: '警告',
              content: '考试中途不得切换页面，超出'+this.userPaperInfo.jumpOutLimit+'次后将强制中断考试！',
            });
          }
        })
      }
    },
    //全屏
    fullScreen() {
      let element = document.documentElement;
      let requestMethod = element.requestFullScreen || //W3C
        element.webkitRequestFullScreen || //Chrome
        element.mozRequestFullScreen || //FireFox
        element.msRequestFullScreen; //IE11
      if (requestMethod) {
        requestMethod.call(element);
      } else if (typeof window.ActiveXObject !== "undefined") { //for Internet Explorer
        let wscript = new ActiveXObject("WScript.Shell");
        if (wscript !== null) {
          wscript.SendKeys("{F11}");
        }
      }
    },
    //退出全屏
    exitFullscreen() {
      this.exitingFullscreen = true
      if (window.document.exitFullscreen) {
        window.document.exitFullscreen()
      } else if (document.mozCancelFullScreen) {
        window.document.mozCancelFullScreen()
      } else if (document.webkitExitFullscreen) {
        window.document.webkitExitFullscreen()
      }
      //退出全屏会触发onblur，所以要有延迟判定
      let that = this
      window.setTimeout(function(){
          that.exitingFullscreen = false
      }, 5000)
    },
    //是否全屏
    isFullscreen(){
       return document.fullscreenElement    ||
         document.msFullscreenElement  ||
         document.mozFullScreenElement ||
         document.webkitFullscreenElement || false;
    }
  },
}
</script>

<style lang="less" scoped>
.ant-layout {
  width: 100%;
  background: transparent;
}
.ant-layout-header {
  background: #fff;
  border-bottom: solid 1px gray;
}
.ant-layout-sider {
  background: #fff;
  text-align: center;
}
.ant-modal{
  padding-bottom:0;
  .ant-modal-close{
    top: -15px;
    right: -15px;
  }
}
.remain-time {
  color: red;
  font-size: 20px;
}
.question-index {
  text-align: left;
  .question-section {
    margin: 10px 0px;
  }
  .ant-tag {
    height: 30px;
    width: 30px;
    font-size: 14px;
    line-height: 28px;
    font-weight: 600;
    text-align: center;
    color: rgb(35,155,215);
  }
  .tip{
    margin-top: 20px;
    color: gray;
    p{
      margin-bottom: 5px;
    }
  }
}
.paper-content {
  .question-card {
    /deep/.ant-card-body{
      padding: 10px 5px!important;
    }
  }
  .question-section {
    margin: 10px 0;
    background: rgb(238,238,238);
    padding: 3px;
    *{
      display: inline;
    }
    
  }
  .question-stem {
    width: 100%;
    max-height: 500px;
    overflow: auto;
    span,
    > div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .question-options {
    display: inline-block;
  }
}
</style>